import { Module, VuexModule, Action } from "vuex-module-decorators";
import { createPartnerPayment } from "@/services/partnerpayment";

@Module({
  namespaced: true
})
export default class Payment extends VuexModule {
  @Action
  public async createPartnerPaymentByTenant(payload) {
    try {
      const data = await createPartnerPayment(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }
}
